import { Container, Stack, Title } from '@mantine/core'
import React from 'react'
import { useTheme } from './ThemeProvider'

interface LabeledContainerProps {
  title: string
}

export default function LabeledContainer({ title }: LabeledContainerProps) {
  const theme = useTheme()

  return (
    <Stack align="center" justify="center" gap={0}>
      <Container
        style={{
          background: theme?.primaryColor,
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
          padding: '10px 32px',
          textAlign: 'center',
          position: 'relative',
        }}
      >
        <Title order={4} c={'white'}>
          {title}
        </Title>
      </Container>
    </Stack>
  )
}
